// Client wrapper for the Worker's /api/rdap endpoint.

export type RdapOk = {
  ok: true;
  domain: string;
  statuses: string[];
  registrar: string | null;
  registrarUrl: string | null;
  nameservers: string[];
  dnssec: boolean | null;
  events: { action: string; date: string }[];
  registered: string | null;
  expires: string | null;
  updated: string | null;
};
export type RdapErr = { ok: false; supported: boolean; message: string };

/** IP / ASN registrations, served by the RIRs rather than a domain registry. */
export type RdapNetOk = {
  ok: true;
  kind: "ip" | "asn";
  query: string;
  handle: string | null;
  name: string | null;
  type: string | null;
  country: string | null;
  startAddress: string | null;
  endAddress: string | null;
  cidr: string[];
  ipVersion: string | null;
  asnRange: string | null;
  org: string | null;
  abuseEmail: string | null;
  registry: string | null;
  events: { action: string; date: string }[];
};

export type RdapResult = RdapOk | RdapNetOk | RdapErr;

export function isNetResult(r: RdapResult): r is RdapNetOk {
  return r.ok === true && "kind" in r;
}

/** Accepts a domain, an IPv4/IPv6 address, or an AS number. */
export async function fetchRdap(query: string, signal?: AbortSignal): Promise<RdapResult> {
  const res = await fetch(`/api/rdap?query=${encodeURIComponent(query)}`, { signal });
  return (await res.json()) as RdapResult;
}

// "2024-01-15T00:00:00Z" → "Jan 15, 2024". Returns the raw string on parse fail.
export function fmtDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

// Days until expiry (negative = already expired). null if unknown/unparseable.
export function daysUntil(iso: string | null): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return Math.round((d.getTime() - Date.now()) / 86400000);
}
